import { styled } from "styled-components";

import { redundantCssFromKebab } from "../../styles/redundant-css";

export const List = styled.ul<{ justified?: boolean }>`
    ${redundantCssFromKebab("align-items", "center")}
    ${redundantCssFromKebab("display", "flex")}
    ${redundantCssFromKebab("flex-wrap", "wrap")}
    ${redundantCssFromKebab("list-style-type", "none")}

    li {
        ${redundantCssFromKebab("display", "flex")}
        ${redundantCssFromKebab("padding", "0 1rem 1rem")}

        img {
            ${redundantCssFromKebab("display", "block")}
            ${redundantCssFromKebab("margin", "auto")}
        }
    }

    ${({ justified }) =>
        justified
            ? `
        justify-content: space-between;
        margin: 0 -1rem; 
        padding: 1rem 0;
      `
            : `
        justify-content: center;
        margin: 0;
        padding: 1rem;
    `}
`;
